import { useEffect, useRef } from 'react';
import './Features.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
      </svg>
    ),
    title: 'Работает без интернета',
    description: 'Данные сохраняются на планшете и отправляются на сервер при появлении связи. Синхронизация происходит автоматически.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
    title: 'Защита от подделки',
    description: 'Динамический QR-код постоянно меняется. Скриншот не поможет — система работает только с живым кодом на экране телефона.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
      </svg>
    ),
    title: 'Быстрое внедрение',
    description: 'Установите приложение на планшет, создайте аккаунты сотрудников — можно работать. Обучение не требуется.'
  },
  {
    icon: <span style={{ fontSize: '1.8em', fontWeight: '500' }}>₽</span>,
    title: 'Доступная стоимость',
    description: 'Один планшет на объект — 15-20 тысяч рублей. Специальное оборудование не требуется. Сотрудники используют свои телефоны.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
      </svg>
    ),
    title: 'Любое количество объектов',
    description: 'Система поддерживает неограниченное количество объектов и сотрудников. Настройка ролей и прав доступа под вашу структуру.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    title: 'Удаленный доступ',
    description: 'Смотрите статистику посещений из любого места. Данные обновляются в реальном времени. Веб-панель работает на любом устройстве.'
  }
];

export default function Features() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Добавляем класс только если его еще нет и элемент виден
          if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
            entry.target.classList.add('animated');
            // Останавливаем наблюдение после первой анимации
            observer.unobserve(entry.target);
          }
        });
      },
      { 
        threshold: 0.2,
        rootMargin: '-50px'
      }
    );

    const cards = sectionRef.current?.querySelectorAll('.feature-card');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="features" ref={sectionRef} data-scroll-section>
      <div className="container">
        <h2 className="section-title">Почему Recvisit?</h2>
        <p className="section-subtitle">Шесть причин выбрать нашу систему</p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
